(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.calendar', indexController);

    indexController.$inject = ["modules.goals.calendar.service", "modules.goals.service", "$stateParams", "mobiEvent"];

    function indexController(calendarService, engagementGoalsService, $stateParams, event) {
        var vm = this;

        vm.Tasks = [];
        vm.events = [];

        vm.GetTasks = GetTasks;

        function GetTasks() {            
            engagementGoalsService.GetTasks(true, BizPartCoreHelpers.getDateNow().subtract(3, 'months'), BizPartCoreHelpers.getDateNow().add(3, 'months')).then(GetTasksCallback);

            function GetTasksCallback(response) {
                vm.Tasks = BizPartCoreHelpers.getResponseValue(response, []);

                vm.events = [];
                for (var i = 0; i < vm.Tasks.length; i++) {
                    var task = vm.Tasks[i];
                    var color = "#65AEF2";
                    
                    if(task.IsCompleted) {
                        color = "#3dd452";
                    }

                    vm.events.push(new event(task.Id, "TASK", task.Text, task.DateLocal, null, color));
                }
            }
        }

        vm.$onInit = function () {
            vm.GetTasks();
        }
    }

})(window.angular);
